import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DomeTurret/g5-turret-ultra.jpg";
import image from "../../assets/product-list-assets/cameras/dome-and-turret/g5-turret-ultra.jpg";
import type { Product } from "../../types";
import { domeTurret } from "../product-groups/cameraSecurity/DomeTurret";
import { domeTurret as productListDomeTurret } from "../product-list-groups/domeTurret";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g5TurretUltra: Product = {
  id: "g5TurretUltra",
  productTitle: "G5 Turret Ultra",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g5-turret-ultra`,
  ],
  storePathParts: {
    productSlug: "uvc-g5-turret-ultra",
    category: UniFiChildCategorySlug.CamerasDomeTurret,
  },
  description: "g5TurretUltra.description",
  descriptionMaxWidth: 160,
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productGroup: domeTurret,
  productListGroup: productListDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø90 x 71.2 mm\n(Ø3.5 x 2.8")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/2.4" CMOS' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g5TurretUltra.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "30 m (98 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.microphone" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
